import React, {useContext} from "react";
import {Text, Image, View} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import {PrintDocumentContext} from "./printDocumentContext";

const PrintDocumentHeader = (props) => {
  const {styles, jobId, fabricatorData, printLogo} = props;

  const date = new Date();
  const printContext = useContext(PrintDocumentContext);
  return (
    <View style={styles.header}>
      <View style={styles.headerInfo}>
        {document.kvConfig.jobId || jobId ? (
          <View style={styles.headerText}>
            <Text style={styles.headerTextBold}>{printContext.messages["receipt.header.quoteNumber"]}</Text>
            <Text style={styles.headerTextValue}>{document.kvConfig.jobId || jobId}</Text>
          </View>
        ) : null}
        <View style={styles.headerText}>
          <Text style={styles.headerTextBold}>{printContext.messages["receipt.header.date"]}</Text>
          <Text style={styles.headerTextValue}>{date.toLocaleDateString().replace(/\//gi, "-")}</Text>
        </View>
        <View style={styles.headerText}>
          <Text style={styles.headerTextBold}>{printContext.messages["receipt.header.time"]}</Text>
          <Text style={styles.headerTextValue}>{date.toLocaleTimeString()}</Text>
        </View>
      </View>
      {printLogo ? (
        <View style={fabricatorData.isRona ? [styles.headerLogo, styles.headerLogoRona] : styles.headerLogo}>
          <Image style={styles.headerLogoImage} source={{ uri: printLogo, method: "GET", headers: { "Cache-Control": "no-cache" } }} />
        </View>
      ) : null}
    </View>
  )
};

PrintDocumentHeader.propTypes = {
  fabricatorData: PropTypes.object,
  jobId: PropTypes.number,
  styles: PropTypes.object.isRequired,
  printLogo: PropTypes.string,
};

export default PrintDocumentHeader
